import { useMemo, useState } from 'react';

// KIR-5098: one search rule for every endpoint drill-down list — the typed text
// (trimmed, case-insensitive) is contained in the endpoint name or machine ID.
export const ENDPOINT_SEARCH_PLACEHOLDER = 'Search endpoint name or ID';

/** True when the query is blank, or the name or ID contains it. */
export function matchesEndpointQuery(
  query: string,
  name: string | null | undefined,
  machineId: string | null | undefined
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [name, machineId].some(v => !!v && v.toLowerCase().includes(q));
}

/**
 * Client-side endpoint search over rows that are already fully loaded.
 * Pass a module-level `endpointOf` so the memo stays stable.
 */
export function useEndpointSearch<T>(
  rows: T[],
  endpointOf: (row: T) => {
    name: string | null | undefined;
    machineId: string | null | undefined;
  }
): {
  query: string;
  setQuery: (value: string) => void;
  filtered: T[];
  isFiltering: boolean;
} {
  const [query, setQuery] = useState('');
  const filtered = useMemo(
    () =>
      rows.filter(row => {
        const { name, machineId } = endpointOf(row);
        return matchesEndpointQuery(query, name, machineId);
      }),
    [rows, query, endpointOf]
  );
  return { query, setQuery, filtered, isFiltering: query.trim() !== '' };
}
